export const PROVINCES = [
  'Adana','Adıyaman','Afyonkarahisar','Ağrı','Amasya','Ankara','Antalya','Artvin','Aydın',
  'Balıkesir','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı',
  'Çorum','Denizli','Diyarbakır','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir',
  'Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Isparta','Mersin','İstanbul','İzmir',
  'Kars','Kastamonu','Kayseri','Kırklareli','Kırşehir','Kocaeli','Konya','Kütahya','Malatya',
  'Manisa','Kahramanmaraş','Mardin','Muğla','Muş','Nevşehir','Niğde','Ordu','Rize','Sakarya',
  'Samsun','Siirt','Sinop','Sivas','Tekirdağ','Tokat','Trabzon','Tunceli','Şanlıurfa','Uşak',
  'Van','Yozgat','Zonguldak','Aksaray','Bayburt','Karaman','Kırıkkale','Batman','Şırnak',
  'Bartın','Ardahan','Iğdır','Yalova','Karabük','Kilis','Osmaniye','Düzce',
];

export const HOME_SIZES = ['1+0', '1+1', '2+1', '3+1', '4+1', '5+1 ve üzeri', 'Ofis / Kurumsal', 'Parça Eşya'];

export const PHONE_DISPLAY = '0533 916 61 08';
export const PHONE_TEL = 'tel:+905339166108';
export const WHATSAPP_URL =
  'https://wa.me/905339166108?text=Merhaba%2C%20evden%20eve%20nakliyat%20i%C3%A7in%20fiyat%20teklifi%20almak%20istiyorum.';

export const LOGO_URL =
  'https://customer-assets-gfyr7b9c.emergentagent.net/job_97796001-027d-49b3-adf1-6985df8286fa/artifacts/b280e1538cf849aa_WhatsApp%20Image%202026-10-20%20at%2018.33.35.jpeg';

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtb3ZpbmclMjB0cnVja3xlbnwwfHx8fDE3OTI1MTA3NTd8MA&ixlib=rb-4.1.0&q=85',
  packing: 'https://images.pexels.com/photos/4554242/pexels-photo-4554242.jpeg',
  transport: 'https://images.pexels.com/photos/15084344/pexels-photo-15084344.jpeg',
  movers: 'https://images.pexels.com/photos/7464406/pexels-photo-7464406.jpeg',
  interior: 'https://images.pexels.com/photos/3434533/pexels-photo-3434533.jpeg',
  about: 'https://images.unsplash.com/photo-1714647211902-bb711d643a17?crop=entropy&cs=srgb&fm=jpg',
};

export const SERVICES = [
  {
    id: 'evden-eve',
    icon: 'Home',
    title: 'Evden Eve Nakliyat',
    desc: 'Eşyalarınızı kapınızdan alıp yeni evinize kurulum yapılmış şekilde teslim ediyoruz. Demontaj, taşıma ve montaj tek elden.',
  },
  {
    id: 'sehirlerarasi',
    icon: 'Truck',
    title: 'Şehirlerarası Taşımacılık',
    desc: 'İnegöl çıkışlı, Türkiye\u2019nin 81 iline güvenli ve planlı şehirlerarası ev taşıma. Tüm illerden İnegöl\u2019e de hizmet veriyoruz.',
  },
  {
    id: 'asansorlu',
    icon: 'ArrowUpToLine',
    title: 'Asansörlü Taşıma',
    desc: 'Yüksek katlarda merdiven riski olmadan, dış cephe asansörü ile hızlı ve hasarsız taşıma imkânı.',
  },
  {
    id: 'paketleme',
    icon: 'Package',
    title: 'Paketleme & Ambalajlama',
    desc: 'Kırılacak eşyalarınız özel ambalaj malzemeleriyle tek tek sarılır, etiketlenir ve kategorize edilir.',
  },
  {
    id: 'depolama',
    icon: 'Warehouse',
    title: 'Eşya Depolama',
    desc: 'Taşınma arasında eşyalarınızı güvenli, temiz ve nemden korunmuş depolarımızda muhafaza ediyoruz.',
  },
  {
    id: 'ofis',
    icon: 'Briefcase',
    title: 'Ofis & Kurumsal Taşıma',
    desc: 'İş kaybını en aza indiren planlama ile ofis, büro ve kurumsal taşımacılık çözümleri.',
  },
];

export const STATS = [
  { value: '81', label: 'İle Teslimat' },
  { value: '15+', label: 'Yıllık Deneyim' },
  { value: '5000+', label: 'Taşınan Ev' },
  { value: '%100', label: 'Sigortalı Taşıma' },
];

export const CITIES = [
  'İstanbul',
  'Ankara',
  'İzmir',
  'Bursa',
  'Antalya',
  'Adana',
  'Konya',
  'Gaziantep',
  'Mersin',
  'Kayseri',
  'Eskişehir',
  'Samsun',
  'Trabzon',
  'Diyarbakır',
  'Balıkesir',
  'Muğla',
  'Tekirdağ',
  'Denizli',
];

export const MARQUEE_ITEMS = [
  'İNEGÖL\u2019DEN TÜM TÜRKİYE\u2019YE',
  '81 İLE TESLİMAT',
  'SİGORTALI TAŞIMACILIK',
  'ASANSÖRLÜ NAKLİYAT',
  'ÜCRETSİZ EKSPERTİZ',
  '7/24 DESTEK',
];

export const PROCESS_STEPS = [
  {
    no: '01',
    title: 'Ücretsiz Keşif',
    desc: 'Bizi arayın, eşyalarınızı yerinde veya görüntülü olarak ücretsiz ekspertiz yapalım.',
  },
  {
    no: '02',
    title: 'Net Fiyat Teklifi',
    desc: 'Sürpriz maliyet yok. Taşıma planınız ve sabit fiyatınız sözleşmeyle garanti altında.',
  },
  {
    no: '03',
    title: 'Paketleme & Yükleme',
    desc: 'Uzman ekibimiz tüm eşyalarınızı sigortalı şekilde paketler, asansörle yükler.',
  },
  {
    no: '04',
    title: 'Teslimat & Kurulum',
    desc: 'Yeni adresinizde demontaj-montaj dahil, eşyalarınız yerli yerinde teslim edilir.',
  },
];

export const GALLERY = [
  { src: IMAGES.movers, title: 'Özenli Taşıma', tag: 'Evden Eve', span: 'tall' },
  { src: IMAGES.packing, title: 'Profesyonel Paketleme', tag: 'Ambalaj', span: 'wide' },
  { src: IMAGES.transport, title: 'Şehirlerarası Filo', tag: 'Lojistik', span: 'wide' },
  { src: IMAGES.hero, title: 'Türkiye Yollarında', tag: '81 İl', span: 'tall' },
  { src: IMAGES.interior, title: 'Yeni Evinizde Kurulum', tag: 'Montaj', span: 'wide' },
  { src: IMAGES.about, title: 'Ekspertiz & Planlama', tag: 'Keşif', span: 'wide' },
];

export const TESTIMONIALS = [
  {
    name: 'Mehmet K.',
    route: 'İnegöl → İstanbul',
    text: 'Eşyalarımız tek bir çizik bile olmadan taşındı. Ekip sabah tam saatinde geldi, akşam yeni evimizde kurulum bitmişti.',
    rating: 5,
  },
  {
    name: 'Ayşe D.',
    route: 'Ankara → İnegöl',
    text: 'Asansörlü taşıma sayesinde 4. kattan hiç zorlanmadan indiler. Kırılacak eşyalarımın hepsi sapasağlam geldi.',
    rating: 5,
  },
  {
    name: 'Hasan Y.',
    route: 'İnegöl → İzmir',
    text: 'Keşifte ne fiyat verdiysek o çıktı, sürpriz masraf yok. Sözleşmeli ve sigortalı çalışmaları güven verdi.',
    rating: 5,
  },
  {
    name: 'Fatma S.',
    route: 'Bursa → Antalya',
    text: 'Paketleme o kadar profesyoneldi ki mutfak eşyalarını bile tek tek sardılar. Hiçbir şeyle uğraşmadık.',
    rating: 5,
  },
  {
    name: 'Emre T.',
    route: 'İnegöl → Trabzon',
    text: 'Uzun yol olmasına rağmen her şey zamanında ve eksiksiz teslim edildi. Şoförden paketlemeciye herkes işinin ehli.',
    rating: 5,
  },
  {
    name: 'Zeynep A.',
    route: 'İstanbul → İnegöl',
    text: 'WhatsApp\u2019tan yazdım, aynı gün fiyat aldım, iki gün sonra taşındık. Bu kadar hızlı olacağını beklemiyordum.',
    rating: 5,
  },
];
